// @ts-nocheck

import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import AppActions from 'app/shared/flux/actions/AppActions';

// Components
// Contact components are now handled by the modal manager system
import ErrorModal from 'app/shared/modules/ErrorModal';
import HdpReviewsModal from 'app/shared/modules/reviews/HdpReviewsModal';
import PopupModal from 'app/shared/modules/popups/PopupModal';
import PostContactRenterProfile from 'app/shared/modules/popups/PostContactRenterProfile';
import Report from 'app/shared/modules/hdp/form/Report';
import WaitlistSuccessPopup from 'app/shared/modules/hdp/form/WaitlistSuccessPopup';
import InstantTour from 'app/shared/modules/hdp/InstantTour';
import ZillowApplicationPopup from 'app/shared/modules/hdp/ZillowApplicationsPopup';

// Misc
import { CostsAndFeesModal } from 'app/shared/modules/hdp/CostsAndFees';
import type { RootReduxState } from 'app/shared/flux/reducers';
import { getWebviewModalFromQuery } from 'app/shared/utils/modalUtils';

const ActionPopupWrapper = (props = {}) => {
  const dispatch = useDispatch();
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails.currentListing) || null;
  const similarListings = useSelector((state: RootReduxState) => state.fetchListing.similarListings) || [];
  const userExists = useSelector((state: RootReduxState) => state.app.userExists);
  const isMobile = useSelector(
    (state: RootReduxState) => state.app.device.screenWidth === 'sm' || state.app.device.screenWidth === 'xs',
  );
  const isWebview = useSelector(
    (state: RootReduxState) => getWebviewModalFromQuery(state.location.ssrEntry.query) !== null,
  );

  const { componentName = '', onActionPopup = () => {}, onHidePopup = () => {}, unitDetails = {} } = props;

  const postContactRenterProfileClose = useCallback(() => {
    onHidePopup();
  }, [dispatch, onHidePopup]);

  if (!listing) {
    return null;
  }

  if (componentName === 'BookTourNowButton' || componentName === 'ModifyTourCTA') {
    return (
      <PopupModal
        aria-labelledby="book-tour-now-title"
        onHidePopup={onHidePopup}
        paddingBottom="0"
        paddingTop="0"
        useCloseButton={!isWebview}
      >
        <InstantTour
          listing={listing}
          isModifyingTour={componentName === 'ModifyTourCTA'}
          onActionPopup={onActionPopup}
          onHidePopup={onHidePopup}
        />
      </PopupModal>
    );
    // Contact modals are now handled by the modal manager system
    // Legacy contact handling has been removed
  } else if (componentName === 'costsAndFeesModal') {
    return <CostsAndFeesModal onHidePopup={onHidePopup} isWebview={isWebview} />;
  } else if (componentName === 'postContactRenterProfile') {
    // Note: This should be migrated to ModalContext, but keeping for backward compatibility
    return (
      <PopupModal aria-labelledby="dialog-title" onHidePopup={postContactRenterProfileClose} scrollContainerOverride>
        <PostContactRenterProfile onHidePopup={onHidePopup} />
      </PopupModal>
    );
  } else if (componentName === 'waitlistSuccess') {
    return (
      <PopupModal aria-labelledby="dialog-title" onHidePopup={onHidePopup} paddingInline="4x">
        <WaitlistSuccessPopup onHidePopup={onHidePopup} similarListings={similarListings} />
      </PopupModal>
    );
  } else if (componentName === 'report') {
    return (
      <PopupModal onHidePopup={onHidePopup} aria-labelledby="dialog-title" position="top" paddingInline="2x">
        <Report onHidePopup={onHidePopup} listing={listing} />
      </PopupModal>
    );
  } else if (componentName === 'error') {
    return (
      <PopupModal aria-labelledby="dialog-title" onHidePopup={onHidePopup} paddingInline="3x">
        <ErrorModal onHidePopup={onHidePopup} />
      </PopupModal>
    );
  } else if (componentName === 'zillowApplications') {
    return (
      <PopupModal aria-labelledby="dialog-title" onHidePopup={onHidePopup} paddingTop="0" paddingBottom="0">
        <ZillowApplicationPopup onActionPopup={onActionPopup} onHidePopup={onHidePopup} />
      </PopupModal>
    );
  }

  return null;
};

ActionPopupWrapper.propTypes = {
  onActionPopup: PropTypes.func,
  onHidePopup: PropTypes.func,
  componentName: PropTypes.oneOf([
    'BookTourNowButton',
    'contact',
    'contactSuccess',
    'contactTourStatusModule',
    'costsAndFeesModal',
    'error',
    'ModifyTourCTA',
    'postContactRenterProfile',
    'report',
    'waitlistSuccess',
  ]),
};

export default ActionPopupWrapper;
